<template>
    <div class="offcanvas offcanvas-bottom action-sheet" tabindex="-1" :id="'storeScore_' + cargo_id">
        <div class="offcanvas-header">
            <h5 class="offcanvas-title">ثبت امتیاز به صاحب بار</h5>
        </div>
        <div class="offcanvas-body">
            <div class="action-sheet-content">
                <form>
                    <star-rating v-model:rating="postData.value" :show-rating="false" :animate="true" padding="1"
                        :border-width="2" />
                    <div class="form-group boxed mt-3">
                        <div class="input-wrapper">
                            <textarea v-model="postData.description" id="description" rows="3"
                                placeholder="نظر خود را بنویسید" class="form-control"></textarea>
                            <i class="clear-input">
                                <ion-icon name="close-circle" role="img" class="md hydrated"
                                    aria-label="close circle"></ion-icon>
                            </i>
                        </div>
                    </div>
                    <div class="form-group basic">
                        <button type="button" @click.prevent="submitRate" :disabled="loadingButton == 1"
                            class="btn background-TEAL btn-block" data-bs-dismiss="offcanvas">
                            <span v-if="loadingButton == 1" class="spinner-border spinner-border-sm" role="status"
                                aria-hidden="true"></span>
                            ثبت
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
    <div class="offcanvas offcanvas-bottom action-sheet" tabindex="-1" :id="'updateScore_' + cargo_id">
        <div class="offcanvas-header">
            <h5 class="offcanvas-title">ویرایش امتیاز</h5>
        </div>
        <div class="offcanvas-body">
            <div class="action-sheet-content">
                <form>
                    <star-rating v-model:rating="postData.value" :show-rating="false" :animate="true" padding="1"
                        :border-width="2" />
                    <div class="form-group boxed mt-3">
                        <div class="input-wrapper">
                            <textarea v-model="postData.description" id="description" rows="3"
                                placeholder="نظر خود را بنویسید" class="form-control"></textarea>
                            <i class="clear-input">
                                <ion-icon name="close-circle" role="img" class="md hydrated"
                                    aria-label="close circle"></ion-icon>
                            </i>
                        </div>
                    </div>
                    <div class="form-group basic">
                        <button type="button" @click.prevent="submitRate" :disabled="loadingButton == 1"
                            class="btn background-TEAL btn-block text-light" data-bs-dismiss="offcanvas">
                            <span v-if="loadingButton == 1" class="spinner-border spinner-border-sm" role="status"
                                aria-hidden="true"></span>
                            ثبت
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import StarRating from 'vue-star-rating'

export default {
    props: [
        'titleCard',
        'owner_id',
        'cargo_id',
        'rate',
    ],
    components: {
        StarRating,
    },
    data() {
        return {
            postData: {
                owner_id: this.owner_id,
                driver_id: window.localStorage.getItem("idUser"),
                loadingButton: 0,
                value: this.rate == null ? 5 : this.rate,
                description: '',
                type: 'Driver',
            }
        }
    },
    methods: {
        submitRate() {
            this.loadingButton = 1;
            axios.post("https://dashboard.iran-tarabar.ir/api/score", this.postData)
                .then((res) => {
                    if (res.status == 200) {
                        this.loadingButton = 0;
                        // this.rate = this.postData.value;
                        this.$emit(this.rate, this.postData.value);
                        // console.log(this.postData.value);
                        Swal.fire({
                            position: "center",
                            icon: "success",
                            title: "نظر شما با موفقیت ثبت شد",
                            showConfirmButton: false,
                            timer: 2000
                        });
                    }
                })
                .catch(function (error) {
                    // handle error
                    console.log(error);
                });
        },
    }
    // mounted() {
    //   console.log(this.data);
    // }
}
</script>
<style>
.peyment-cart {
    border: 1px solid;
    border-radius: 10px;
    margin-bottom: 9px;
}

.btn-peyment-copy {
    border-color: #d9d9d9;
}

.text-cart-number {
    font-weight: 800;
    font-size: 20px
}
</style>